import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { QrCodeModule } from "../batchstamp/qr-code/qr-code.module";
import { StaticStampService } from "app/common/services/StaticStamp.service";
import { StaticReportComponent } from "./static_report.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    BsDatepickerModule.forRoot(),
    QrCodeModule
  ],
  declarations: [StaticReportComponent],
  providers: [StaticStampService],
  entryComponents: []
})
export class StaticReportModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_report/static_report.module.ts